import type { CaseMetric } from "@/types/content";

// interface Metric {

//     label: string;

//     value: string;
// }

interface MetricGridProps {

    metrics: CaseMetric[];
}

export function MetricGrid({
    metrics,
}: MetricGridProps) {
    return (

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">

            {metrics.map((metric) => (

                <div
                    key={metric.label}
                    className="rounded-2xl border border-border bg-card p-6"
                >

                    <div className="text-3xl font-bold">

                        {metric.value}

                    </div>

                    <div className="mt-3 text-sm text-muted-foreground">

                        {metric.label}

                    </div>

                </div>

            ))}

        </div>

    );
}